const list={
    GSYH:[
        {
            showField:"交易日期",
            entityField:"backDate",
            fieldWeight:120,
        },
        {
            showField:"付款方",
            entityField:"cmName",
            fieldWeight:120,
        },
        {
            showField:"金额",
            entityField:"money",
            fieldWeight:120,
            isSort:1,
            isTotal:1,
        },
        {
            showField:"银行",
            entityField:"bank",
            fieldWeight:120,
        },
        {
            showField:"银行账号",
            entityField:"bankAccount",
            fieldWeight:120,
        },
        {
            showField:"账簿",
            entityField:"summary",
            fieldWeight:120,
        },
    ],
    ZYYH:[
        {
            showField:"交易日期",
            entityField:"backDate",
            fieldWeight:120,
        },
        {
            showField:"付款方",
            entityField:"cmName",
            fieldWeight:120,
        },
        {
            showField:"金额",
            entityField:"money",
            fieldWeight:120,
            isSort:1,
            isTotal:1,
        },
        {
            showField:"银行",
            entityField:"bank",
            fieldWeight:120,
        },
        {
            showField:"银行账号",
            entityField:"bankAccount",
            fieldWeight:120,
        },
        {
            showField:"账簿",
            entityField:"summary",
            fieldWeight:120,
        },
    ],
    ZDY:[
        {
            showField:"交易日期",
            entityField:"backDate",
            fieldWeight:120,
        },
        {
            showField:"付款方",
            entityField:"cmName",
            fieldWeight:120,
        },
        {
            showField:"金额",
            entityField:"money",
            fieldWeight:120,
            isSort:1,
            isTotal:1,
        },
        {
            showField:"银行",
            entityField:"bank",
            fieldWeight:120,
        },
        {
            showField:"银行账号",
            entityField:"bankAccount",
            fieldWeight:120,
        },
        {
            showField:"备注",
            entityField:"remark",
            fieldWeight:120,
        },
        {
            showField:"读取状态",
            entityField:"abnormalFlag",
            fieldWeight:120,
        },
    ]
}
export default list
